import { isStoreUrl } from '../../supabase/functions/_shared/appVersion.ts';

/**
 * The store page a "new version" push asks the app to open, or null. Only the App Store and
 * Google Play's own pages are accepted, so a push can never send the app anywhere else.
 */
export function storeUrlFromPush(data: Record<string, unknown> | null | undefined): string | null {
  const url = data?.store_url;
  return isStoreUrl(url) ? url : null;
}
